import { useQuery } from 'react-query';
import { queryGuestSpaceAvailable } from 'api/guestSpace';
var useGuestSpaceAvailable = function (params, options) { return useQuery(['getGuestSpaceAvailable', params], function () { return queryGuestSpaceAvailable(params); }, options); };
export default useGuestSpaceAvailable;
